<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row>
        <v-col cols="8"><h3>Central de Mensagens</h3></v-col>
        <v-col class="text-right">
          <v-btn @click="newTopic()" dark depressed color="green darken-2" class="mt-2 mx-2">
            Novo Tópico
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="my-3"></v-divider>
      <v-row class="mt-1">
        <v-col v-if="sellers.length > 1">
          <v-select
            v-model="sellersFilter"
            label="Seller"
            outlined
            hide-details
            dense
            :items="sellers"
            item-text="sellerId"
            item-value="sellerId"
            clearable
          ></v-select>
        </v-col>
        <v-col cols="8">
          <v-autocomplete
            :items="orders"
            item-text="orderIdMarketplace"
            item-value="orderIdMarketplace"
            v-model="filterOrder"
            label="Pedido"
            placeholder="Pesquisar Número do Pedido"
            outlined
            dense
            hide-details
            clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>

      <v-row>
        <v-col cols="4" v-if="topics" class="base-fixed">
          <div class="fixed-top">
            <v-alert class="pa-1" color="indigo darken-1" dark>
              <v-tabs background-color="indigo darken-1" dark class="caption pw-0" v-model="tab">
                <v-tab class="pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-badge color="green" :content="topicFiltered.open.length" :value="topicFiltered.open.length">
                        <v-icon small v-on="on">mdi-message</v-icon>
                      </v-badge>
                    </template>
                    <span>Abertos</span>
                  </v-tooltip>
                </v-tab>
                <v-tab class="pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on">mdi-message</v-icon>
                    </template>
                    <span>Atenção</span>
                  </v-tooltip>
                </v-tab>
                <v-tab class="pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-badge color="amber" :content="topicFiltered.archived.length" :value="topicFiltered.archived.length">
                        <v-icon small v-on="on">mdi-message-text-clock</v-icon>
                      </v-badge>
                    </template>
                    <span>Arquivados</span>
                  </v-tooltip>
                </v-tab>
                <v-tab class="pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-badge color="red" :content="topicFiltered.close.length" :value="topicFiltered.close.length">
                        <v-icon small v-on="on">mdi-message-text-lock-outline</v-icon>
                      </v-badge>
                    </template>
                    <span>Fechados</span>
                  </v-tooltip>
                </v-tab>
                <v-tab class="pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-badge color="blue" :content="topicFiltered.seller.length" :value="topicFiltered.seller.length">
                        <v-icon small v-on="on">mdi-store</v-icon>
                      </v-badge>
                    </template>
                    <span>Sellers</span>
                  </v-tooltip>
                </v-tab>
              </v-tabs>
            </v-alert>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <div v-for="(item, i) in topicFiltered.open" :key="i">
                  <v-card color="caption blue-grey lighten-5" flat class="mt-2 pa-2" @click="viewTopic(item)">
                    {{ item.orderIdMarketplace }} - {{ item.topicSubject }}
                  </v-card>
                </div>
                <div v-if="!topicFiltered.open">
                  <i> Nenhum Tópico no Momento </i>
                </div>
              </v-tab-item>
              <v-tab-item>
                <i> Nenhum Tópico no Momento </i>
              </v-tab-item>
              <v-tab-item>
                <div v-for="(item, i) in topicFiltered.archived" :key="i">
                  <v-card color="caption blue-grey darken-3" flat class="mt-2 pa-2" dark @click="viewTopic(item)">
                    {{ item.orderIdMarketplace }} - {{ item.topicSubject }}
                  </v-card>
                </div>
                <div v-if="!topicFiltered.archived">
                  <i> Nenhum Tópico no Momento </i>
                </div>
              </v-tab-item>
              <v-tab-item>
                <div v-for="(item, i) in topicFiltered.close" :key="i">
                  <v-card color="caption blue-grey lighten-2" flat class="mt-2 pa-2" @click="viewTopic(item)">
                    {{ item.orderIdMarketplace }} - {{ item.topicSubject }}
                  </v-card>
                </div>
                <div v-if="!topicFiltered.close">
                  <i> Nenhum Tópico no Momento </i>
                </div>
              </v-tab-item>
              <v-tab-item>
                <div v-for="(item, i) in topicFiltered.seller" :key="i">
                  <v-card color="caption blue-grey lighten-2" flat class="mt-2 pa-2" @click="viewTopic(item)">
                    {{ item.orderIdMarketplace }} - {{ item.topicSubject }}
                  </v-card>
                </div>
                <div v-if="!topicFiltered.seller">
                  <i> Nenhum Tópico no Momento </i>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-col>

        <v-col cols="8" class="ml-message color--blue-grey-lighten-5" v-if="messages">
          <v-alert border="bottom" color="indigo darken-1" dark v-if="messages.length > 0">
            <v-row align="center">
              <v-col class="grow">Mensagens do Tópico</v-col>
              <v-col class="shrink">
                <v-btn icon color="white" small @click="reverseTopic(topic)">
                  <v-icon v-if="!messageDirection">mdi-format-text-rotation-vertical</v-icon
                  ><v-icon v-if="messageDirection">mdi-format-text-rotation-up</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </v-alert>
          <v-alert
            border="bottom"
            color="amber darken-1"
            dark
            v-if="!topic.topicId && !newTopicFlag && !this.$route.params.orderIdMarketplace && !filterOrder"
          >
            <v-icon left>mdi-alert</v-icon>
            Selecione um Tópico
          </v-alert>

          <div v-for="(item, i) in messages" :key="i">
            <v-expand-transition>
              <v-card class="mb-5 pa-1" outlined>
                <v-card-title class="mb-message py-0">
                  <span class="caption" v-if="item.topicSubject"
                    >assunto: <b> {{ item.topicSubject }} </b> - {{ item.orderIdMarketplace }}</span
                  >
                  <v-spacer></v-spacer>
                  <span class="caption font-weight-light">#{{ i }}</span>
                  <v-icon small right>
                    mdi-message
                  </v-icon>
                </v-card-title>
                <v-card-text class="py-5">
                  <div v-html="item.messageBody"></div>
                </v-card-text>
                <v-card-actions class="caption font-weight-light text-right mt-message  py-0">
                  <v-spacer></v-spacer>
                  <i
                    >Por: <b>{{ item.idUser }}</b> em {{ item.messageCreation | formatFullDate }} </i
                  ><br />
                </v-card-actions>
              </v-card>
            </v-expand-transition>
          </div>

          <div v-if="!messages && !newTopicFlag">
            <i> Nenhuma Mensagem no Momento </i>
          </div>
          
          <div v-if="newTopicFlag || (topic.topicStatus != 2 && topic.topicId)">
            <div v-if="newTopicFlag">
              <v-alert border="bottom" color="indigo darken-1" dark class="ma-0">
                Novo Topico
              </v-alert>
              <v-row>
                <v-col cols="6">
                  <v-text-field hide-details label="Título" outlined dense v-model="topicSubject"></v-text-field>
                </v-col>
                <v-col>
                  <v-autocomplete
                    :items="ordersFiltered"
                    item-text="orderIdMarketplace"
                    item-value="orderIdMarketplace"
                    v-model="orderIdMarketplace"
                    placeholder="Numero do Pedido"
                    label="Pedido"
                    outlined
                    dense
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-select
                    label="Seller"
                    outlined
                    hide-details
                    dense
                    :items="sellers"
                    item-text="sellerId"
                    item-value="sellerId"
                    v-model="newTopicSeller"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <vue-editor v-model="messageAnswer" />
            <v-btn @click="saveMessage()" depressed color="primary" class="mt-2 mx-2">
              Responder
            </v-btn>
            <v-btn @click="changeTopicStatus(2)" depressed color="red darken-2" dark class="mt-2  mx-2" v-if="!newTopicFlag">
              Fechar
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import { baseApiUrl, showError } from '@/global'

export default {
  name: 'Messages',
  data: () => ({
    activeTopic: null,
    topics: {
      open: [],
      close: [],
      archived: [],
    },
    messageDirection: true,
    filterOrder: null,
    topic: {},
    messages: [],
    messageAnswer: '',
    newTopicFlag: false,
    newTopicSeller: null,
    topicSubject: '',
    orderIdMarketplace: '',
    sellers: [],
    sellersFilter: [],
    tab: [],
    orders: [],
  }),
  components: { VueEditor },
  methods: {
    loadTopics() {
      this.loading = true
      const url = `${baseApiUrl}/topic`
      axios
        .get(url)
        .then((res) => {
          this.topics = res.data
          this.loadOrders()
          this.loading = false
        })
        .catch(showError)
    },
    loadSellers() {
      this.loading = true
      const url = `${baseApiUrl}/seller`
      axios
        .get(url)
        .then((res) => {
          this.sellers = res.data
          this.sellersFilter = this.sellers.map((el) => el.sellerId)
          this.loading = false
        })
        .catch(showError)
    },
    loadOrders() {
      this.loading = true
      const url = `${baseApiUrl}/topic/listOrders`
      axios
        .get(url)
        .then((res) => {
          this.orders = res.data
          this.ordersFiltered = this.orders
          this.loading = false
        })
        .catch(showError)
    },
    viewTopic(topic) {
      this.loading = true
      this.newTopicFlag = false
      const url = `${baseApiUrl}/topic/${topic.topicId}`
      axios
        .get(url)
        .then((res) => {
          this.messages = res.data
          this.topic = topic
          this.activeTopic = topic.topicId
          this.messageAnswer = ''
          this.loading = false
        })
        .catch(showError)
    },
    viewTopicByOrderId(orderIdMarketplace) {
      this.loading = true
      this.newTopicFlag = false
      const url = `${baseApiUrl}/order/${orderIdMarketplace}/messages`
      axios
        .get(url)
        .then((res) => {
          this.messages = res.data
          this.topic = {}
          this.activeTopic = orderIdMarketplace
          this.messageAnswer = ''
          this.loading = false
        })
        .catch(showError)
    },
    saveMessage() {
      this.loading = true
      const topicId = this.activeTopic
      let url = ''

      let body = {
        message: this.messageAnswer,
      }

      if (this.newTopicFlag) {
        url = `${baseApiUrl}/topic`
        body.topicSubject = this.topicSubject
        body.orderIdMarketplace = this.orderIdMarketplace
      } else {
        url = `${baseApiUrl}/topic/${topicId}`
      }

      if (this.newTopicSeller) {
        body.sellerId = this.newTopicSeller
      }

      axios
        .post(url, body)
        .then((res) => {
          this.loadTopics()
          this.messageAnswer = ''
          this.topicSubject = ''
          this.orderIdMarketplace = ''
          this.loading = false
        })
        .catch(showError)
    },
    newTopic() {
      this.newTopicFlag = true
      this.messages = []
      this.messageAnswer = ''
    },
    changeTopicStatus(status) {
      const topicId = this.activeTopic
      const url = `${baseApiUrl}/topic/${topicId}`
      const body = { status: status }
      axios
        .put(url, body)
        .then((res) => {
          this.loadTopics()
          this.messageAnswer = ''
          this.loading = false
        })
        .catch(showError)
    },
    computeTopic() {
      if (!this.sellersFilter && !this.filterOrder) {
        return this.topics
      }

      let topicOpen = []
      let topicClose = []
      let topicArchived = []
      let topicSeller = []
      if (this.sellersFilter && !this.filterOrder) {
        if (this.topics.open) {
          topicOpen = this.topics.open.filter((el) => {
            if (this.sellersFilter.includes(el.sellerId)) {
              return el
            }
          })
        }
        if (this.topics.close) {
          topicClose = this.topics.close.filter((el) => {
            if (this.sellersFilter.includes(el.sellerId)) {
              return el
            }
          })
        }
        if (this.topics.archived) {
          topicArchived = this.topics.archived.filter((el) => {
            if (this.sellersFilter.includes(el.sellerId)) {
              return el
            }
          })
        }
        if (this.topics.seller) {
          topicSeller = this.topics.seller.filter((el) => {
            if (this.sellersFilter.includes(el.sellerId)) {
              return el
            }
          })
        }
      } else {
        if (this.topics.open) {
          topicOpen = this.topics.open.filter((el) => {
            if (el.orderIdMarketplace === this.filterOrder) {
              return el
            }
          })
        }
        if (this.topics.close) {
          topicClose = this.topics.close.filter((el) => {
            if (el.orderIdMarketplace === this.filterOrder) {
              return el
            }
          })
        }
        if (this.topics.archived) {
          topicArchived = this.topics.archived.filter((el) => {
            if (el.orderIdMarketplace === this.filterOrder) {
              return el
            }
          })
        }
        if (this.topics.seller) {
          topicSeller = this.topics.seller.filter((el) => {
            if (el.orderIdMarketplace === this.filterOrder) {
              return el
            }
          })
        }
      }

      return {
        open: topicOpen,
        close: topicClose,
        archived: topicArchived,
        seller: topicSeller,
      }
    },
    reverseTopic() {
      this.messageDirection = !this.messageDirection
      this.messages.reverse()
    },
  },
  computed: {
    topicFiltered() {
      return this.computeTopic()
    },
  },
  watch: {
    newTopicSeller() {
      if (!this.newTopicSeller) {
        this.ordersFiltered = this.orders
      } else {
        this.ordersFiltered = this.orders.filter((order) => {
          if (order.sellerId === this.newTopicSeller) {
            return order
          }
        })
      }
    },
  },
  mounted() {
    this.loadTopics()
    this.loadSellers()

    if (this.$route.path.includes('new')) {
      this.newTopicFlag = true
      this.orderIdMarketplace = this.$route.params.orderIdMarketplace
    } else if (this.$route.params.orderIdMarketplace) {
      this.viewTopicByOrderId(this.$route.params.orderIdMarketplace)
    }
  },
}
</script>

<style>
.mt-message {
  border-top: 1px solid #cecece;
}
.mb-message {
  border-bottom: 1px solid #cecece;
}

.ml-message {
  border-right: 1px solid #cecece;
}

.fixed-top {
  top: 80px;
  position: sticky;
  position: -webkit-sticky;
}
.base-fixed {
  position: relative;
}
</style>
